import routes from "@/routes";
import { lazy } from "react";
const NativeOffer = lazy(() => import("@/modules/Asset/NativeOffer"));
const DisplayListNativeOffer = lazy(
  () => import("@/modules/Asset/NativeOffer/ListNativeOffer")
);
const CreateOrEditAsset = lazy(
  () => import("@/modules/Asset/NativeOffer/CreateOrEditAsset")
);

const AssetRoutes = {
  element: <NativeOffer />,
  path: routes.ASSETS.NATIVE_OFFERS.INDEX,

  children: [
    {
      element: <DisplayListNativeOffer />,
      path: "",
    },
    {
      element: <CreateOrEditAsset />,
      path: routes.ASSETS.NATIVE_OFFERS.CREATE,
    },
    {
      element: <CreateOrEditAsset isEdit />,
      path: routes.ASSETS.NATIVE_OFFERS.EDIT(),
    },
  ],
};

export default AssetRoutes;
